import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const inactiveIngredientList = (props) => {
	return (
		<DataTable
			value={props.inactiveIngredients}
			paginator={true}
			lazy={true}
			rows={props.rows}
			totalRecords={props.totalRecords}
			onPage={(event) => props.onPageClick(event)}
			first={props.first}
		>
			<Column header="Name"
				body={(rowData, column) =>
					rowData && rowData.inactiveIngredientContent && rowData.inactiveIngredientContent.length ?
						rowData.inactiveIngredientContent
							.filter(x => typeof x.name === 'string' && x.name.length > 0)
							.map(r => r.name)
							.join(' / ')
						: null
				} />
			<Column
				header="Actions"
				style={{ textAlign: "center", width: "8em" }}
				body={(rowData, column) =>
					<div>
						<Button
							type="button"
							icon="pi pi-pencil"
							className="p-button-warning"
							tooltip="Edit"
							tooltipOptions={{ position: 'top' }}
							style={{ marginRight: ".5em" }}
							onClick={() => props.editClick(rowData.inactiveIngredientId)}
						/>
						<Button
							type="button"
							icon="pi pi-trash"
							className="p-button-danger"
							tooltip="Delete"
							tooltipOptions={{ position: 'top' }}
							onClick={() => props.deleteClick(rowData.inactiveIngredientId)}
						/>
					</div>
				}
			/>
		</DataTable>
	)
}

export default inactiveIngredientList;
